// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__qYbXY","child":"Dashboard_child__T6Xrk"};